import React, { FC } from 'react';
import {
  DownloadIconCont,
  ResourcesTableTileCont,
  ResourceTitle,
} from './ResourcesTableTile.styles';
import { ISuplementaryResourceItem } from '../../../services/reports';
import DownloadIcon from '@/assets/icons/download.svg?react';

interface IResourcesTableTile {
  item: ISuplementaryResourceItem;
}
const ResourcesTableTile: FC<IResourcesTableTile> = ({ item }) => {
  const { title, downloadUrl } = item;
  return (
    <ResourcesTableTileCont id="ResourcesTableTileCont">
      <ResourceTitle id="ResourceTitle">{title}</ResourceTitle>
      <DownloadIconCont
        data-testid="pdflink"
        id="DownloadIconCont"
        href={downloadUrl}
        target="_blank"
        download
      >
        <DownloadIcon />
      </DownloadIconCont>
    </ResourcesTableTileCont>
  );
};
export default ResourcesTableTile;
